import axios, { AxiosError } from 'axios';

const api = axios.create({
  baseURL: 'https://api.chytanka.com/gateway', 
});

api.interceptors.response.use(
  ({data}) => data,
  (error: AxiosError) => Promise.reject(error)
)

export default api;